export default __webpack_public_path__ + "static/door3-a8cdcce1b1fc137744a69b624f7e27f1.jpg";